import { render, staticRenderFns } from "./Avvisi.vue?vue&type=template&id=329e4b26&"
import script from "./Avvisi.vue?vue&type=script&lang=js&"
export * from "./Avvisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports